import { z } from "zod";
import {
  SILO_PLATFORM_LOCATION_VALUES,
  SILO_STATUS_VALUES,
  SILO_TYPE_VALUES,
} from "./constants";

/**
 * Absolute / optional world position
 */
// export const siloPositionSchema = z.object({
//   latitude: z.float64().min(-90).max(90).optional(),
//   longitude: z.float64().min(-180).max(180).optional(),
//   altitudeM: z.float64().optional(),
// });

/**
 * Position relative to platform structure
 */
export const siloPlatformLocationSchema = z.object({
  /**
   * Human-readable mounting zone
   */
  zone: z.enum(SILO_PLATFORM_LOCATION_VALUES).optional(),

  /**
   * Exact local offsets from platform origin point (meters)
   */
  offsetXM: z.float64().optional(), // left/right
  offsetYM: z.float64().optional(), // forward/back
  offsetZM: z.float64().optional(), // up/down

  /**
   * Mount orientation
   */
  headingDeg: z.float64().min(0).max(360).optional(),
  pitchDeg: z.float64().min(-90).max(90).optional(),
  rollDeg: z.float64().min(-180).max(180).optional(),

  /**
   * Deck / level / bay
   */
  level: z.string().optional(),
  section: z.string().optional(),
});

/**
 * SILO
 */
export const siloSchema = z.object({
  dbId: z.string().optional(),

  siloId: z.string().min(1, "Silo ID is required"),
  // name: z.string().min(1, "Silo name is required"),

  // platformId: z.string().optional(),

  // type: z.enum(SILO_TYPE_VALUES).default("VERTICAL_LAUNCH"),
  status: z.enum(SILO_STATUS_VALUES),

  /**
   * SKOPA inventory
   */
  capacity: z.int().min(1),
  currentInventory: z.int().min(0),

  zone: z.enum(SILO_PLATFORM_LOCATION_VALUES),

  /**
   * Global optional coordinates
   */
  // position: siloPositionSchema.optional(),

  /**
   * REQUIRED relation to platform placement
   */
  // platformLocation: siloPlatformLocationSchema,

  /**
   * Timing
   */
  // reloadTimeSeconds: z.int().min(0).optional(),
  // launchCooldownSeconds: z.int().min(0).optional(),

  /**
   * Control
   */
  // armed: z.boolean().default(false),
  // locked: z.boolean().default(true),
  // autoFireEnabled: z.boolean().default(false),

  /**
   * Health
   */
  // healthPercent: z.int().min(0).max(100).default(100),

  /**
   * Service
   */
  // lastReloadAt: z.coerce.date().optional(),
  // lastMaintenanceAt: z.coerce.date().optional(),

  // notes: z.string().optional(),
  // tags: z.array(z.string()).default([]),

  // createdAt: z.coerce.date().default(() => new Date()),
  // updatedAt: z.coerce.date().default(() => new Date()),
});
// .refine((data) => data.currentInventory <= data.capacity, {
//   message: "Current inventory cannot exceed capacity",
//   path: ["currentInventory"],
// })
// .refine((data) => data.currentInventory <= data.capacity, {
//   message: "Inventory + reserved cannot exceed capacity",
//   path: ["reservedInventory"],
// });

/**
 * MULTIPLE
 */
export const silosSchema = z.object({
  silos: z.array(siloSchema).min(1),
});

/**
 * TYPES
 */
export type Silo = z.infer<typeof siloSchema>;
export type Silos = z.infer<typeof silosSchema>;
